import request from "@/utils/request";

export function getBilingData() {
    return request({
        url: '/get-biling',
        method: 'post',
    });
}

export function getBilingHistory(data) {
    return request({
        url: '/get-biling-history',
        method: 'post',
        data: data,
    });
}

export function unSubscribe(data) {
    return request({
        url: '/unsubscribe',
        method: 'post',
        data: data,
    });
}

export function createCardSesion(data) {
    return request({
        url: '/create-card-sesion',
        method: 'post',
        data: data,
    });
}

export function reNew(data) {
    return request({
        url: '/re-new',
        method: 'post',
        data: data,
    });
}

export function subscribeDel(data) {
    return request({
        url: '/subscribe-del',
        method: 'post',
        data: data,
    });
}

export function buySingle(data) {
    return request({
        url: '/payments/create_single_payment',
        method: 'post',
        data: data,
    });
}

export function getDataBuySingle() {
    return request({
        url: '/get-data-buy-single',
        method: 'post'
    });
}

export function deleteCard(data) {
    return request({
        url: '/delete-card',
        method: 'post',
        data: data,
    });
}


